import React, { useEffect, useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getRandomItemImage } from "../api";
import bosPng from "../assets/bos.png";
import { getDetailLink } from "../utils/utilFunction";

function RandomImageCard() {
  const [imageList, setImageList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRandomImages = async () => {
    setLoading(true);
    try {
      const res = await getRandomItemImage(3);
      if (res?.status && Array.isArray(res?.data) && res.data.length > 0) {
        setImageList(res.data);
      } else {
        setImageList([]);
      }
    } catch {
      setImageList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRandomImages();
  }, []);

  if (loading && imageList.length === 0) {
    return (
      <div className="random-image-card">
        <div className="d-flex justify-content-between mb-3">
          <h2 className="title _set">Görseller</h2>
        </div>
        <Row>
          {Array.from({ length: 3 }).map((_, i) => (
            <Col key={`skeleton-${i}`} xs={12} md={4} className="mb-4">
              <div className="random-image-card__item random-image-card__item--skeleton" />
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  if (!imageList.length) {
    return null;
  }

  return (
    <div className="random-image-card">
      <div className="d-flex justify-content-between mb-3">
        <h2 className="title _set">Görseller</h2>
        <Link
          className="seeAll"
          to="#"
          onClick={(e) => {
            e.preventDefault();
            fetchRandomImages();
          }}
        >
          Yenile
        </Link>
      </div>

      <Row>
        {imageList.map((imageItem) => (
          <Col key={imageItem.fileId} xs={12} md={4} className="mb-4">
            <div className="random-image-card__item">
              <div className="random-image-card__image">
                <Link to={getDetailLink(imageItem)}>
                  <Image
                    alt={imageItem.docTypeTitle || imageItem.title}
                    src={imageItem.url || bosPng}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = bosPng;
                    }}
                  />
                </Link>
              </div>
              <div className="random-image-card__body">
                {imageItem.docTypeTitle ? (
                  <p className="random-image-card__caption">
                    {imageItem.docTypeTitle}
                  </p>
                ) : null}
                {imageItem.source ? (
                  <p className="random-image-card__source">{imageItem.source}</p>
                ) : null}
                {imageItem.title ? (
                  <p className="random-image-card__item-title">
                    Madde: <strong>{imageItem.title}</strong>
                  </p>
                ) : null}
                <Link
                  to={getDetailLink(imageItem)}
                  className="random-image-card__go"
                >
                  İlgili maddeye git »
                </Link>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default RandomImageCard;
